import { render, staticRenderFns } from "./RenderPostManager.vue?vue&type=template&id=b5834778&scoped=true&"
import script from "./RenderPostManager.vue?vue&type=script&lang=js&"
export * from "./RenderPostManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5834778",
  null
  
)

export default component.exports